import React, { Component } from 'react';
import styled from 'styled-components';
import { Container, MainContent } from '../components';
import logoCircle from '../assets/logo/RJ_circle_512.png';

export const CommonContainer = styled.div`
  height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding: 1rem 1rem 3rem;
  color: var(--text);
`;

const StyledImg = styled.img`
  width: 100%;
  max-width: 200px;
  height: auto;
  margin: 2rem auto 3rem;
  display: block;
`;

const Title = styled.h1`
  text-align: center;
  font-family: var(--text-title);
  color: var(--text);
  margin: 1rem 0;
  font-size: 2rem;
`;

class Home extends Component {
  render() {
    return (
      <Container>
        <MainContent>
          <CommonContainer>
            <StyledImg src={logoCircle} alt="Logo" />
            <Title>Raquel y Juan</Title>
          </CommonContainer>
        </MainContent>
      </Container>
    );
  }
}

export default Home;
